import Officer1 from "../assets/images/officer1.png";
import Officer2 from "../assets/images/sandra.jpg";
import Officer4 from "../assets/images/uzochukwu.jpg";
import Officer5 from "../assets/images/asiru.png";
import Officer6 from "../assets/images/liphie.png";
import Officer7 from "../assets/images/tope.jpg";
import Officer8 from "../assets/images/iheoma.jpeg";
import Officer9 from "../assets/images/avater.png";
import Officer10 from "../assets/images/mbalisi.jpg";
import Officer11 from "../assets/images/abeya.png";
import Officer12 from "../assets/images/justin.jpg";
import Officer13 from "../assets/images/tope2.JPG";
import Officer14 from "../assets/images/peace.png";
import Officer15 from "../assets/images/micheal.jpg";
import Officer16 from "../assets/images/nwokoafor.jpg";
import Officer17 from "../assets/images/ajala.jpg";
import Officer18 from "../assets/images/dumo.png";
import Officer20 from "../assets/images/razak.jpg";
export const members = [
  {
    profileImg: Officer1,
    email: "asovinchidi@yahoo.com",
    affiliation: "University of Eswatini, Eswatini ",
    profileInfo:
      "Vincent Chidindu Asogwa, a Senior Lecturer in the Department of Agricultural Education and Extension at the University of Eswatini, was born in Agudele Obukpa, Nsukka, Enugu State, Nigeria. His academic journey began at the University of Nigeria, Nsukka (UNN), where he obtained his B.Sc. (2006), M.Ed. (2010), and PhD degrees in Agricultural Education (2014). Complementing his academic qualifications, he pursued professional training in Entrepreneurship in Agriculture at the Songhai Centre, Porto-Novo, Republic of Benin. With a career spanning both secondary education and academia, Asogwa's teaching path started immediately after graduation in 2006, followed by a tenure at the College of Education in Nsukka (2009–2012). He then transitioned to the Federal University of Agriculture, Makurdi, Benue State, in 2012, before joining the Michael Okpara University of Agriculture, Umudike, Abia State, in 2015, and finally the University of Eswatini in 2019. In his role as an educator, Asogwa has supervised numerous academic projects, including 3 PhD dissertations, 17 Master’s theses, and over 103 undergraduate projects since 2012. His scholarly contributions extend to over 138 publications, encompassing 2 books, 9 book chapters, 32 conference papers, 89 journal articles, and 4 newspaper articles. Additionally, he has attended over 32 conferences, webinars, and workshops both nationally and internationally since 2009. Dedicated to advancing agricultural education, Asogwa is an active member of nine professional organizations, including the Agricultural Education Teachers Association of Nigeria (where he serves as Journal Managing Editor), the International Society for Development and Sustainability Japan, and the Association for International Agricultural and Extension Education USA, Eswatini Education Research Association among others. Personally, he is married to Mrs. Joy Nnedinso Asogwa, and together they have two daughters, Janefrances Chihurumnanya Asogwa and Joy Sochinwekene Asogwa.",

    profilePortfolio: "President",
    profileQualification: "PhD in Biotechnology",
    profileName: "Vincent Chidindu Asogwa ",

    id: 1,
  },
  {
    profileImg: Officer2,
    email: "sandra.augustine@uniport.edu.ng",
    affiliation: "University of Port Harcourt ",

    profileInfo:
      "I am an Educational Technologist and a Lecturer 1 in the Department of Curriculum Studies and Educational Technology, Faculty of Education, University of Port Harcourt, Rivers State, Nigeria. I am interested in designing blended instructions and utilizing cutting edge technologies and pedagogies to engage learners and promote their learning experiences and performances.",

    profilePortfolio: "General Secretary",
    profileQualification: "MD, PhD in Epidemiology",
    profileName: "Augustine Sandra Eberechukwu",

    id: 2,
  },
  {
    profileImg: Officer4,
    email: "uzochukwu.iyida@unn.edu.ng",
    affiliation: "University of Nigeria Nsukka ",

    profileInfo: "",

    profilePortfolio: "Member",
    profileQualification: "PhD in Agricultural Economics",
    profileName: "Everistus Uzochukwu Iyida",

    id: 3,
  },
  {
    profileImg: Officer5,
    email: "asirubabatunde@gmail.com",
    affiliation: "University of Ibadan, Nigeria  ",

    profileInfo: "",

    profilePortfolio: "Member",
    profileQualification: "MSc in Electrical Engineering",
    profileName: "Abdullahi Babatunde Asiru ",

    id: 4,
  },
  {
    profileImg: Officer6,
    email: "liphie@uniswa.sz",
    affiliation: "University of Eswatini, Eswatini ",

    profileInfo: "",

    profilePortfolio: "Member",
    profileQualification: "MD, MPH in Global Health",
    profileName: "Liphie Pereira ",

    id: 5,
  },
  {
    profileImg: Officer7,
    email: "topeandb@gmail.com",
    affiliation: "Lagos State University of Education ",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Bakare, Tope Oke  ",

    id: 6,
  },
  {
    profileImg: Officer8,
    email: "ngeremuk@gmail.com",
    affiliation: "MICHAEL OKPARA UNIVERSITY OF AGRICULTURE, UMUDIKE",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Eucharia Iheoma Ngerem  ",

    id: 7,
  },
  {
    profileImg: Officer9,
    email: "olukemiayeni074@gmail.com",
    affiliation: "Abia State University, Uturu, Nigeria",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Julianah Olukemi Ayeni",

    id: 8,
  },
  {
    profileImg: Officer10,
    email: "onyeka.mbalisi@uniport.edu.ng",
    affiliation:
      "Department of Adult and Non-Formal Education, Faculty of Education, University of Port Harcourt ",

    profileInfo:
      "I am an Associate Professor of Adult Education and Environmental Education with not less than Sixteen Years cognate teaching experience in the University of Port Harcourt. My research interests include areas such as climate change, environmental ethics, effective methods of communication of environmental education contents, environmental pollution, population and the environment, etc.",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Mbalisi Onyeka Festus ",

    id: 8,
  },
  {
    profileImg: Officer11,
    email: "abeyairimiah@gmail.com",
    affiliation:
      "University of Nigeria, Nsukka/Department of Quality Assurance, Abuja",

    profileInfo: "",

    profilePortfolio: " Member, Research and development Committee",
    profileQualification: "PhD in Education Policy",
    profileName: "Irimiah Abeya Ezhim  ",

    id: 10,
  },
  {
    profileImg: Officer12,
    email: "ugwujustin@gmail.com",
    affiliation: "University College Dublin",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Justin Ugwu ",

    id: 11,
  },
  {
    profileImg: Officer13,
    email: "topeandb@gmail.com",
    affiliation: "Lagos State University of Education ",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Bakare Tope Oke  ",

    id: 12,
  },
  {
    profileImg: Officer14,
    email: "peaceginika@rocketmail.com",
    affiliation: "University of Johannesburg South Africa  ",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Peace Ginika Nwokedi",

    id: 13,
  },
  {
    profileImg: Officer15,
    email: "gbengamichael944@gmail.com",
    affiliation: "Ahmadu Bello University, Zaria ",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Michael Olugbenga",

    id: 14,
  },
  {
    profileImg: Officer16,
    email: "chinelonwokafor@gmail.com",
    affiliation: "Michael Okpara University of Agriculture Umudike Abia State",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Nwokafor, Chinelo Lilian",

    id: 15,
  },
  {
    profileImg: Officer17,
    email: "ajalaos@lasued.edu.ng",
    affiliation: "LAGOS STATE UNIVERSITY OF EDUCATION ",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Ajala Oluwole Samuel",

    id: 16,
  },
  {
    profileImg: Officer18,
    email: "dumobobmanuel@gmail.com",
    affiliation: "Rivers State University  ",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Dumo Patience Bobmanuel  ",

    id: 17,
  },
  {
    profileImg: Officer9,
    email: "adegbenro0464@gmail.com",
    affiliation: "Lagos State University of Education Otto Ijanikin",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Sokunbi, Gbenro Matthew ",

    id: 18,
  },
  {
    profileImg: Officer20,
    email: "adefabiadetunji@gmail.com",
    affiliation: "Emmanuel Alayande University of Education, Oyo ",

    profileInfo: "",

    profilePortfolio: " Member",
    profileQualification: "PhD in Education Policy",
    profileName: "Rasak Adetunji ADEFABI ",

    id: 19,
  },
];
